import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'logged_out_retailers-supplier_page_bottom_carousel-click';

/**
 * This event tracking tracks when the bottom carousel is seen on supplier pages for all of C1, C2 and C3 category level
 */
export function trackLoggedOutRetailersSupplierPageBottomCarouselClick(
  categoryLevel: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { categoryLevel },
  });
}
